<script setup lang="ts">
import { useElementSize } from '@vueuse/core'
import allHistory from './components/all-history.vue'
// import currentlyEffect from './components/currently-effect.vue'
// import potential from './components/potential.vue'

definePage({
  name: 'find',
  meta: {
    title: '发现-港股通',
  },
})
const refsList = useTemplateRef('refsList') as any
const refsPageLayout = useTemplateRef('refsPageLayout')
const refTabConten = useTemplateRef('refTabConten')
const { height: tabContenHeight } = useElementSize(refTabConten, undefined, { box: 'border-box' })
const active = ref(0)

const navbarHeight = computed(() => {
  return `${refsPageLayout.value?.navbarHeight || 0}px`
})

const tabsList = ref([
  {
    name: '流入',
    val: 0,
  },
  {
    name: '流出',
    val: 1,
  },
])

const components: any = {
  0: allHistory,
  1: allHistory,
}

function onTabChange() {
  nextTick(() => {
    if (refsList.value) {
      refsList.value.reLoad()
    }
  })
}
</script>

<template>
  <FmPageLayout ref="refsPageLayout" navbar back class="fluctuation-page" :search="false">
    <div ref="refTabConten" class="tab-conten" :style="{ top: navbarHeight }">
      <van-tabs v-model:active="active" line-width="9px" @change="onTabChange">
        <van-tab v-for="item in tabsList" :key="item.val" :title="item.name" />
      </van-tabs>
    </div>
    <div :style="{ height: `${tabContenHeight}px` }" />
    <component :is="components[active]" ref="refsList" v-model:type="active" />
  </FmPageLayout>
</template>

<style lang="scss" scoped>
.fluctuation-page {
  :deep(.van-tabs__nav) {
    background-color: #f1f2f7;
  }

  :deep(.van-tab--active) {
    font-size: 17px;
  }

  .tab-conten {
    position: fixed;
    left: 0;
    z-index: 2;
    width: 100%;
  }
}
</style>
